import { FC, SyntheticEvent, useState } from 'react';
import { Container } from '@/components';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import { Remove, Add } from '@mui/icons-material';
import { useTranslation } from 'next-i18next';

import styles from './styles.module.scss';

const FAQItem: FC<{
  id: string;
  title: string;
  content: string;
  expanded: boolean;
  onChange: (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => void;
}> = ({ id, title, content, expanded, onChange }) => {
  return (
    <Accordion
      disableGutters
      className={styles.faqItem}
      expanded={expanded}
      onChange={onChange(id)}
    >
      <AccordionSummary
        className={styles.faqItemSummary}
        classes={{
          content: styles.faqItemSummaryContent,
          expandIconWrapper: styles.faqItemSummaryExpandIconWrapper,
        }}
        expandIcon={expanded ? <Remove /> : <Add />}
      >
        <Typography variant="h4" className={styles.faqItemTitle}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={styles.faqItemDetails}>
        <Typography className={styles.faqItemDetailsContent}>{content}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};

const FAQItems = Array.from({ length: 5 }, (_, index) => index);

export const FAQSection: FC = () => {
  const { t } = useTranslation('pricingV2', { keyPrefix: 'faq' });
  const [expanded, setExpanded] = useState<string | null>(null);

  const handleChange =
    (panel: string) =>
    (_event: SyntheticEvent, isExpanded: boolean): void => {
      setExpanded(isExpanded ? panel : null);
    };

  return (
    <Box component="section" className={styles.section}>
      <Container>
        <Typography variant="h2" className={styles.title}>
          {t('title')}
        </Typography>
        <Box className={styles.faqList}>
          {FAQItems.map((item) => (
            <FAQItem
              key={item}
              id={item.toString()}
              title={t(`items.${item}.q`)}
              content={t(`items.${item}.a`)}
              expanded={expanded === item.toString()}
              onChange={handleChange}
            />
          ))}
        </Box>
      </Container>
    </Box>
  );
};
